"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MobileBar = void 0;
const react_1 = __importDefault(require("react"));
const core_1 = require("@material-ui/core");
const core_2 = require("@material-ui/core");
const styles_1 = require("@material-ui/core/styles");
const Menu_1 = __importDefault(require("@material-ui/icons/Menu"));
const SimpleGrid_1 = require("../../SimpleGrid");
// eslint-disable-next-line @rushstack/typedef-var
const useStyles = styles_1.makeStyles((theme) => styles_1.createStyles({
    appBar: {
        zIndex: theme.zIndex.drawer + 1,
        boxShadow: theme.shadows[0],
        borderBottom: '1px solid rgba(0, 0, 0, 0.12)',
        userSelect: 'none'
    },
    toolbar: {
        paddingLeft: 0,
        paddingRight: 0
    },
    inputRoot: {
        borderColor: 'transparent !important'
    }
}));
const MobileBar = (props) => {
    const classes = useStyles();
    const { showSearchBar = false, searchBarPlaceholder } = props;
    return (react_1.default.createElement(core_1.AppBar, { position: "fixed", color: "inherit", elevation: 1, className: classes.appBar },
        react_1.default.createElement(core_1.Toolbar, { classes: { root: showSearchBar && classes.toolbar } },
            showSearchBar && (react_1.default.createElement(core_2.TextField, { disabled: true, fullWidth: true, placeholder: searchBarPlaceholder, variant: "outlined", InputProps: {
                    classes: {
                        notchedOutline: classes.inputRoot
                    },
                    startAdornment: (react_1.default.createElement(core_2.InputAdornment, { position: "start" },
                        react_1.default.createElement(core_2.IconButton, { disabled: true },
                            react_1.default.createElement(Menu_1.default, null)))),
                    endAdornment: (react_1.default.createElement(core_2.InputAdornment, { position: "end" },
                        react_1.default.createElement(core_2.IconButton, { disabled: true },
                            react_1.default.createElement(core_1.Avatar, null))))
                } })),
            !showSearchBar && (react_1.default.createElement(SimpleGrid_1.SimpleGrid, { left: react_1.default.createElement(core_2.IconButton, { disabled: true },
                    react_1.default.createElement(Menu_1.default, null)), right: react_1.default.createElement(core_2.IconButton, { disabled: true },
                    react_1.default.createElement(core_1.Avatar, null)) }))),
        react_1.default.createElement(core_1.LinearProgress, null)));
};
exports.MobileBar = MobileBar;
//# sourceMappingURL=MobileBar.js.map